import React, { PropTypes } from 'react'
import './style.less'

function CTAButton({ href, label, variation, mini, onClick, submit }) {
  return (
		<span>
		{ submit
			? (<input type="submit" className={`cta-button ${variation} ${mini && 'mini'}`} href={href} onClick={onClick} value={label} />)
			: (<a className={`cta-button ${variation} ${mini && 'mini'}`} href={href} onClick={onClick}>{label}</a>)
		}
	</span>
  )
}

CTAButton.propTypes = {
  href: PropTypes.string,
  label: PropTypes.node.isRequired,
  variation: PropTypes.oneOf(['primary','secondary']),
  mini: PropTypes.bool,
	submit: PropTypes.bool
}

CTAButton.defaultProps = {
	href: '#',
  variation: 'primary',
  mini: false,
	submit: false
}

export default CTAButton



// WEBPACK FOOTER //
// ../components/CTAButton/index.js